import { Link, useRouterState } from "@tanstack/react-router";
import { LANGS, LANG_LABELS } from "@/i18n/config";
import { useLang } from "@/i18n/use-lang";

const SHORT: Record<string, string> = { nl: "NL", en: "EN", fr: "FR" };

/**
 * Language switcher: keeps the current page and only swaps the language segment.
 * Languages are named in words, never flags.
 */
export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const active = useLang();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const localized = /^\/(nl|en|fr)(?=\/|$)/.test(pathname);

  return (
    <nav aria-label="Taal" className={`flex items-center gap-1 ${className}`}>
      {LANGS.map((lang) => (
        <Link
          key={lang}
          {...(localized ? { to: "." as const } : { to: "/$lang" as const })}
          params={{ lang }}
          aria-current={lang === active ? "true" : undefined}
          aria-label={`${SHORT[lang]} — ${LANG_LABELS[lang]}`}
          className={`rounded-[4px] px-2 py-1 text-[13px] font-semibold transition-colors focus-visible:outline-3 focus-visible:outline-offset-2 focus-visible:outline-secondary ${
            lang === active
              ? "text-secondary underline underline-offset-4"
              : "text-primary-foreground/70 hover:text-secondary"
          }`}
        >
          {SHORT[lang]}
        </Link>
      ))}
    </nav>
  );
}
